import { c as _c } from "react/compiler-runtime";
import { useLayoutEffect, useRef, useState } from 'react';
import { useHeaderFlyoutStore } from '../../../shared';
export function useSearchFlyout() {
  const $ = _c(12);
  const inputRef = useRef(null);
  const [open, setOpen] = useState(false);
  const isFlyoutActive = useHeaderFlyoutStore(_temp);
  let t0;
  let t1;
  if ($[0] !== isFlyoutActive) {
    t0 = () => {
      if (!isFlyoutActive) {
        return;
      }
      setOpen(false);
      inputRef.current?.blur();
    };
    t1 = [isFlyoutActive];
    $[0] = isFlyoutActive;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useLayoutEffect(t0, t1);
  let t2;
  if ($[3] !== isFlyoutActive) {
    t2 = function onOpenChange(nextOpen) {
      if (nextOpen && isFlyoutActive) {
        return;
      }
      setOpen(nextOpen);
    };
    $[3] = isFlyoutActive;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const onOpenChange = t2;
  let t3;
  if ($[5] !== isFlyoutActive) {
    t3 = function onInputFocus() {
      if (isFlyoutActive) {
        inputRef.current?.blur();
        return false;
      }
      setOpen(true);
      return true;
    };
    $[5] = isFlyoutActive;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const onInputFocus = t3;
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = function closeSearch() {
      setOpen(false);
      inputRef.current?.blur();
      requestAnimationFrame(() => inputRef.current?.blur());
    };
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const closeSearch = t4;
  let t5;
  if ($[8] !== onInputFocus || $[9] !== onOpenChange || $[10] !== open) {
    t5 = {
      closeSearch,
      inputRef,
      onInputFocus,
      onOpenChange,
      open
    };
    $[8] = onInputFocus;
    $[9] = onOpenChange;
    $[10] = open;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}
function _temp(state) {
  return state.activeFlyout !== null;
}